import getApplication from './getApplication';

export default function isSuper() {
  return getApplication() === 'admin';
}
